var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplashMassage = function SvgSplashMassage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.304 13.802c-.25-.431-.227-.97.069-1.372l.382-.518C25.646 10.706 24.784 9 23.283 9H12.389c-1.5 0-2.363 1.706-1.472 2.912l.383.518c.296.401.319.94.069 1.372-.587 1.014-1.632 2.921-2.099 4.41-.436 1.394-.602 3.176-.644 4.8-.045 1.742.965 3.194 2.428 3.917m14.543-10.692c.319.668.612 1.357.805 1.974.437 1.395.602 3.177.644 4.8.065 2.506-2.052 4.412-4.56 4.412h-8.163"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M14.614 19.267c1.485-2.39 4.962-2.39 6.447 0 1.572 2.528-.246 5.8-3.223 5.8-2.978 0-4.796-3.272-3.224-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M17.71 20.53a.2.2 0 0 1 .347 0l.802 1.39a1.127 1.127 0 1 1-1.951 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M13.212 27.418a.418.418 0 1 1-.836 0 .418.418 0 0 1 .836 0M25.489 15.01a.418.418 0 1 1-.836 0 .418.418 0 0 1 .836 0"
  }))));
};
export default SvgSplashMassage;